import store from "@/store";
import {mapActions, mapGetters, mapState} from "vuex";

export const contactMixin = {
  computed: {
    ...mapGetters({
      orgUpdates: "contacts/contacts",
      totalUpdates: "contacts/selectedCount"
    })
  },
  methods: {
    ...mapActions({
      queueForUpdate: "contacts/addContactForUpdate",
      removeFromQueue: "contacts/removeContactFromUpdate",
      clearQueue: "contacts/clearUpdateContacts"
    }),
    inContactsToUpdate(contactId) {
      let response = {
        exists: false,
        color: ''
      }
      let alreadyExists = this.orgUpdates.findIndex(x => x.contact_id === contactId);
      if (alreadyExists > -1) {
        let currentContact = this.orgUpdates[alreadyExists];
        response.exists = true;
        switch (currentContact.operation) {
          case 'ADD':
            response.color = 'contact-selected';
            break;
          case 'REMOVE':
            response.color = 'contact-removed';
            break;
          case 'SWITCH':
            response.color = 'contact-changed'
            break
            deafult:
              response.color = ''
            break;
        }
      }
      return response
    }
  }
}
